import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-row items-center hover:opacity-50 mr-2 mb-2 cursor-pointer transition-all"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_link, {
    class: "bg-ob-deep-900 text-center px-3 py-1 rounded-tl-md rounded-bl-md text-sm",
    to: {
      name: 'tags-search',
      query: {
        slug: _ctx.slug
      }
    },
    style: _normalizeStyle(_ctx.stylingTag())
  }, {
    default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("em", {
      class: "opacity-50"
    }, "#", -1 /* HOISTED */)), _createTextVNode(" " + _toDisplayString(_ctx.name), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["to", "style"]), _createElementVNode("span", {
    class: "bg-ob-deep-900 text-ob-secondary text-center px-2 py-1 rounded-tr-md rounded-br-md text-sm opacity-70",
    style: _normalizeStyle(_ctx.stylingTag())
  }, _toDisplayString(_ctx.count), 5 /* TEXT, STYLE */)]);
}